export const formatDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string' || dateString.trim() === '') {
    return 'Date not set';
  }
  try {
    const date = new Date(dateString);
    const options = { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  } catch (error) {
    // Handle toLocaleDateString exceptions gracefully
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};